import { render } from "./Frontend.vue?vue&type=template&id=fa5a0332"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Frontend.vue?vue&type=style&index=0&id=fa5a0332&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__